var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-1 title-wrapper"},[_c('div',{staticClass:"row-number"},[_c('small',[_vm._v(_vm._s(_vm.idx + 1))])]),_c('router-link',{staticClass:"router-link",attrs:{"to":_vm.baseUrl + _vm.id,"draggable":"false"}},[_vm._v(" "+_vm._s(_vm.title.toLowerCase().replace(/\s+/g, ''))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }